import { render, staticRenderFns } from "./MyCourses.vue?vue&type=template&id=796e58e7"
import script from "./MyCourses.vue?vue&type=script&lang=js"
export * from "./MyCourses.vue?vue&type=script&lang=js"
import style0 from "./MyCourses.vue?vue&type=style&index=0&id=796e58e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports